import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useAuthContext } from '../../hooks/useAuthContext'
import { getKits } from '../../api/health/bloodKits'
import { getLifestyle } from '../../api/health/lifestyleTools'

const limit = '50'

const useSetup = () => {
	const { user } = useAuthContext()
	const [page, setPage] = useState('1')

	const { isLoading: isLoadingFocus, isError: isErrorFocus, error: errorFocus, data: focus } = useQuery({
		queryKey: ['focus'],
		queryFn: async () => {
			const response = await fetch(`/api/health/api/focus/${user._id}`, {
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${user.token}`
				}
			})

			if (response.status === 204) return null

			const json = await response.json()

			if (!response.ok) throw new Error(json.error)

			return json ?? null
		}
	})

	const { isLoading: isLoadingKits, isError: isErrorKits, error: errorKits, data: kits } = useQuery({
		queryKey: ['kits'],
		queryFn: async () => {
			const response = await getKits(
				user._id,
				user.token,
				page,
				limit
			)

			const json = await response.json()

			if (!response.ok) throw new Error(json.error)

			return json?.data ?? null
		}
	})

	const { isLoading: isLoadingLifestyle, isError: isErrorLifestyle, error: errorLifestyle, data: lifestyle } = useQuery({
		queryKey: ['lifestyleTest'],
		queryFn: async () => {
			const response = await getLifestyle(
				user._id,
				user.token
			)

			if (response.status === 204) return null

			const json = await response.json()

			if (!response.ok) throw new Error(json.error)

			return json ?? null
		}
	})

	const { isLoading: isLoadingTeam, isError: isErrorTeam, error: errorTeam, data: team } = useQuery({
		queryKey: ['team', user?.team?._id],
		queryFn: async () => {
			if (!user.team._id) return null

			const response = await fetch(`/api/health/api/teams/${user.team._id}`, {
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${user.token}`
				}
			})

			const json = await response.json()

			if (!response.ok) throw new Error(json.error)

			return json ?? null
		},
		enabled: !!user?.team?._id
	})

	return {
		isLoadingTeam,
		isErrorTeam,
		errorTeam,
		team,
		isLoadingFocus,
		errorFocus,
		isLoadingKits,
		isErrorFocus,
		isErrorKits,
		errorKits,
		isLoadingLifestyle,
		isErrorLifestyle,
		errorLifestyle,
		focus,
		kits,
		lifestyle,
		user
	}
}

export default useSetup
